import React from 'react';

const TestimonialsSection: React.FC = () => {
  const testimonials = [
    {
      name: "Neerah",
      title: "Accounting Executive, Now Business Owner",
      company: "NG",
      content: "Glory helped me transition from a 6 year accounting career to growing my empire. Her strategic approach and mentorship made what seemed impossible, achievable.",
      image: "https://static.readdy.ai/image/224dc00200a5f30b66b07d4513abc50a/858d51667e125378a6f771b570628fee.jpeg"
    },
    {
      name: "Ejiro Ogboru",
      title: "Serial Entrepreneur",
      company: "Naija Buds",
      content: "Working with Glory on our acquisition strategy doubled our portfolio value in 18 months. Her deal-making expertise and network are unmatched in the Australian market.",
      image: "https://static.readdy.ai/image/224dc00200a5f30b66b07d4513abc50a/2bbce9e818e9804eb8bc6402b3fa507d.jpeg"
    },
    {
      name: "Herve",
      title: "Serial entrepreneur",
      company: "HK Shower Repair",
      content: "Glory's insights into business valuation and her deal team helped us to walk away from a deal that was a real bad lemon as we went through the due diligence process",
      image: "https://static.readdy.ai/image/224dc00200a5f30b66b07d4513abc50a/3c5ae9f478d1e61d274a623ae326c036.jpeg"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-black mb-6 font-serif">
            What Clients <span className="text-yellow-600 italic">Say</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Real results from professionals and business owners who transformed their wealth through strategic ownership.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-gray-50 p-8 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-center mb-6">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-16 h-16 rounded-full object-cover mr-4"
                />
                <div>
                  <h4 className="font-semibold text-gray-800">{testimonial.name}</h4>
                  <p className="text-sm text-gray-600">{testimonial.title}</p>
                  <p className="text-sm text-yellow-600 font-medium">{testimonial.company}</p>
                </div>
              </div>
              
              <div className="mb-4">
                <div className="flex text-yellow-600 mb-3">
                  {[...Array(5)].map((_, i) => (
                    <div key={i} className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-star-fill text-sm"></i>
                    </div>
                  ))}
                </div>
              </div>
              
              <blockquote className="text-gray-700 leading-relaxed">
                "{testimonial.content}"
              </blockquote>
            </div>
          ))}
        </div>

        {/* Stats Section */}
        <div className="mt-16 bg-black p-12 rounded-lg">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-4xl font-bold text-yellow-600 mb-2">14+</div>
              <div className="text-white text-sm">Successful Acquisitions</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-yellow-600 mb-2">$18M+</div>
              <div className="text-white text-sm">Total Deal Value</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-yellow-600 mb-2">90%</div>
              <div className="text-white text-sm">Client Success Rate</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-yellow-600 mb-2">5+</div>
              <div className="text-white text-sm">Years Experience</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
